module.exports = __webpack_public_path__ + "static/img/business-license1.78e7278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/business-license1.png
// module id = Xy3Y
// module chunks = 0